<template>
  <div>
    <vs-popup :title="$t('Pricing')" :active.sync="showModal">
      <form v-if="showModal">
        <vs-input
          class="inputx mb-4 mt-1"
          v-model="model.itemCode"
          name="icode"
          :label="$t('ItemCode')"
          v-validate="'required'"
          :readonly="model.id"
        />
        <span class="text-danger text-sm" v-show="errors.has('icode')">{{
          errors.first("icode")
        }}</span>

        <label class="vs-select--label">{{ $t("BasePrice") }}</label>
        <vs-input
          v-model="price"
          name="bPrice"
          class="mb-4 vs-inputx"
          v-validate="{ required: true }"
        />
        <span class="text-danger text-sm" v-show="errors.has('bPrice')">{{
          errors.first("bPrice")
        }}</span>

        <label class="vs-select--label">{{ $t("ToleranceType") }}</label>
        <div v-if="!model.id">
          <v-select
            label="title"
            name="toleranceType"
            :options="toleranceTypes"
            v-model="model.toleranceType"
            v-validate="{ required: true }"
            :reduce="(x) => x.value"
            class="mb-4"
            dir="rtl"
          >
          </v-select>
        </div>
        <div v-if="model.id">
          <v-select
            label="title"
            name="toleranceType"
            :options="toleranceTypes"
            :value="model.toleranceType == 'Amount' ? 'مقداری' : 'درصدی'"
            @input="toleranceTypeChanged"
            v-validate="{ required: true }"
            :reduce="(x) => x.value"
            class="mb-4"
            dir="rtl"
          >
          </v-select>
        </div>
        <span
          class="text-danger text-sm"
          v-show="errors.has('toleranceType')"
          >{{ errors.first("toleranceType") }}</span
        >

        <vs-input
          class="inputx mb-4"
          v-model="model.allowedReduction"
          name="reductionRate"
          :label="$t('AllowedReduction')"
          v-validate="{ required: true }"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('reductionRate')"
          >{{ errors.first("reductionRate") }}</span
        >

        <vs-input
          class="inputx mb-4"
          v-model="model.allowedIncrease"
          name="increaseRate"
          :label="$t('AllowedIncrease')"
          v-validate="{ required: true }"
        />
        <span class="text-danger text-sm" v-show="errors.has('increaseRate')">{{
          errors.first("increaseRate")
        }}</span>

        <vs-button
          type="filled"
          class="float-right mb-4"
          @click.prevent="submitForm"
          :disabled="disabled"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<style lang="scss">
.removeIco {
  float: left !important;
  top: 10px !important;
  left: 10px !important;
}
</style>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";
const dict = {
  custom: {
    icode: {
      required: "لطفا آیتم کد را وارد نمایید.",
    },
    bPrice: {
      required: "لطفا قیمت پایه را وارد نمایید.",
    },
    reductionRate: {
      required: "لطفا مقدار کاهش مجاز را وارد نمایید.",
    },
    increaseRate: {
      required: "لطفا مقدار افزایش مجاز را وارد نمایید.",
    },
    toleranceType: {
      required: "لطفا نوع تغییرات را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "saleManagement_Priceing_ModifyPopup",
  props: {
    show: { default: false },
    model: {
      default: {},
    },
    keywords: {},
  },
  data() {
    return {
      popupTitle: "",
      toleranceTypes: [
        { value: 1, title: "درصدی" },
        { value: 2, title: "مقداری" },
      ],
      disabled: false,
      price: null,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      addPrice: "price/create",
    }),
    toleranceTypeChanged(toleranceTypeValue) {
      this.model.toleranceType = toleranceTypeValue;
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        this.invalidPrice = false;
        if (result) {
          this.disable = true;
          this.addPrice(this.model).then(() => {
            setTimeout(() => {
              this.$emit("finish");
              this.model = {};
              this.price = null;
              this.$validator.reset();
            }, 2000);
          });
          this.disable = false;
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.price = this.model.basePrice.toLocaleString();
      }
      this.$validator.reset();
    },
    price(value) {
      if (value) {
        var n = parseFloat(value.replace(/,/g, ""), 10);
        this.price = n.toLocaleString();
        this.model.basePrice = this.price.replace(/,/g, "");
      } else {
        this.price = null;
        this.model.basePrice = null;
      }
    },
  },
  components: {
    "v-select": vSelect,
  },
};
</script>
